import { useGameStore } from '../store';
import { fmtTime } from '../utils/format';

export default function StatStrip() {
  const streak = useGameStore((s) => s.stats.streak);
  const trades = useGameStore((s) => s.stats.totalTrades);
  const playSec = useGameStore((s) => s.stats.totalPlaySec);

  return (
    <div id="stat-strip">
      <div className="stat-item streak">
        🔥 <span>연승</span> <span className="v">{streak}</span>
      </div>
      <div className="stat-item">
        💱 <span>거래</span> <span className="v">{trades}</span>
      </div>
      <div className="stat-item">
        ⏱ <span className="v">{fmtTime(playSec)}</span>
      </div>
    </div>
  );
}
